import { render } from "./face-mesh-view.vue?vue&type=template&id=daade9f2"
import script from "./face-mesh-view.vue?vue&type=script&lang=js"
export * from "./face-mesh-view.vue?vue&type=script&lang=js"

import "./face-mesh-view.vue?vue&type=style&index=0&id=daade9f2&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__